import React from 'react'
import { useDateFilterFromQuery } from './useDateFilterFromQuery'
import { DateFilterContext } from './DateFilterContext'
import { DateFilterType } from './dateFilter.types'

type WithDateFilterContextProps = {
  defaultValues?: Partial<DateFilterType>
}

export const WithDateFilterContext: React.FC<WithDateFilterContextProps> = ({
  defaultValues,
  children
}) => {
  const filters = useDateFilterFromQuery(defaultValues)

  return (
    <DateFilterContext.Provider value={filters}>
      {children}
    </DateFilterContext.Provider>
  )
}
